import { registerView, View } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { Button, Col, Row } from "react-bootstrap";
import ChargeManagementReceiptViewModel from "../../../viewModels/chargeManagement/chargeManagementEdit/chargeManagementReceiptViewModel";
import { recaptchaSiteKey } from "../../../config";
import Recaptcha from "reaptcha";
import Portal from "../../eshop/order/components/portal";
import Icon, { IconType } from "@edaz/edazkit/Icon";

const ChargeReceiptView: FunctionComponent<{
  vm: ChargeManagementReceiptViewModel;
}> = observer(({ vm }) => (
  <>
    <Col>
      <Row className="mb-3">
        <Button
          variant="link"
          onClick={vm.downloadPaymentConfirmation}
          className="d-flex align-items-center text-body text-left text-wrap font-weight-normal no-border-radius link-underline p-0 box-shadow-none">
          <div
            className="bg-primary d-flex align-items-center justify-content-center rounded-circle text-white mr-3"
            style={{ height: 40, width: 40, minWidth: 40 }}>
            <Icon icon={IconType.Pdf} width={20} height={20} />
          </div>
          {vm.translate("receipt.downloadReceiptInPDF")}
        </Button>
      </Row>
      <Row>
        <Button
          variant="link"
          onClick={vm.sendPaymentConfirmationEmail}
          className="d-flex align-items-center text-body text-left text-wrap font-weight-normal no-border-radius link-underline p-0 box-shadow-none">
          <div
            className="bg-primary d-flex align-items-center justify-content-center rounded-circle text-white mr-3"
            style={{ height: 40, width: 40, minWidth: 40 }}>
            <Icon icon={IconType.MailOpen} width={20} height={20} />
          </div>
          {vm.translate("receipt.sendReceiptToEmail")}
        </Button>
        {vm.showModal && <View vm={vm.emailInputViewModel} />}
        <Portal>
          <Recaptcha
            hl={vm.localizationService.locale}
            ref={vm.recaptchaRef}
            sitekey={recaptchaSiteKey!}
            onVerify={vm.onRecaptchaVerify}
            size="invisible"
          />
        </Portal>
      </Row>
    </Col>
  </>
));

registerView(ChargeReceiptView, ChargeManagementReceiptViewModel);
